import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useApiClient } from "@shell/apiClientContext";
import { FLOORPLAN_QUERY_KEY } from "../../admin/common/queryKeys";
import { getOfficeFloorplan } from "../../admin/sage-offices/api";
import type { OfficeFloorplanView } from "../../admin/workspaces/types";

export { FLOORPLAN_QUERY_KEY };

export function useOfficeFloorplan(
    sageOfficeId: string | null,
): UseQueryResult<OfficeFloorplanView, Error> {
    const client = useApiClient();
    const id = sageOfficeId?.trim() ?? "";
    return useQuery({
        queryKey: [...FLOORPLAN_QUERY_KEY, id],
        queryFn: () => getOfficeFloorplan(client, id),
        enabled: id !== "",
        staleTime: 30_000,
    });
}
